import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { TipoDeJulgamento } from '@app/models/tipo-de-julgamento.model';
import { TipoDeJulgamentoService } from '@app/services/tipo-de-julgamento.service';


@Component({
  selector: 'app-tipo-de-julgamento-form',
  templateUrl: './tipo-de-julgamento-form.component.html'
})
export class TipoDeJulgamentoFormComponent implements OnInit {

  titulo: string;
  lstErros: string[];
  tipoDeJulgamento: TipoDeJulgamento = new TipoDeJulgamento();
  aguardandoSolicitacao: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tipoDeJulgamentoService: TipoDeJulgamentoService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Tipo de Julgamento' : 'Novo Tipo de Julgamento';

      if (!id) {
        return;
      }

      this.tipoDeJulgamentoService.obterPorId(id).toPromise().then(
        data => this.tipoDeJulgamento = data,
        () => this.router.navigate(['./configuracoes/tipo-de-julgamento']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.tipoDeJulgamentoService.gravar(this.tipoDeJulgamento).toPromise().then(
      () => this.router.navigate(['./configuracoes/tipo-de-julgamento']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
